import IAppStore from "app/IAppStore";
import { StoreSelector } from "./storeSelector";
import { EqualityFn, useSelector } from "react-redux";

export default function useStoreSelector<T>(selector: StoreSelector<T>, equalityFn?: EqualityFn<T>): T
{
    return useSelector((m: IAppStore) => selector(m), equalityFn);
}